import {useCallback, useEffect, useMemo, useState} from "react"

export const useSelectDropdown = () => {
    const [showDropdown, setShowDropdown] = useState(false)

    const {onScroll, closeDropdown} = useMemo(() => {
        const memoizedOnScroll = () => {
            closeDropdown()
        }
        const memoizedCloseDropdown = () => {
            setShowDropdown(false)
            document.removeEventListener("scroll", onScroll)
        }
        return {
            onScroll: memoizedOnScroll,
            closeDropdown: memoizedCloseDropdown,
        }
    }, [setShowDropdown])

    const openDropdown = useCallback(() => {
        setShowDropdown(true)
        document.addEventListener("scroll", onScroll)
    }, [setShowDropdown, onScroll])

    useEffect(() => {
        const handleResize = () => {
            setShowDropdown(false)
        }
        window.addEventListener("resize", handleResize)
        return () => window.removeEventListener("resize", handleResize)
    }, [closeDropdown])

    return {
        showDropdown,
        openDropdown,
        closeDropdown,
    }
}
